const scrollTo = (element, to, duration) => {
  console.log({ element, to, duration });
  var start = element.scrollTop,
    change = to - start,
    currentTime = 0,
    increment = 20;

  var animateScroll = function() {
    currentTime += increment;
    var val = Math.easeInOutQuad(currentTime, start, change, duration);
    // console.log({ val });
    element.scrollTop = val;
    if (currentTime < duration) {
      setTimeout(animateScroll, increment);
    }
  };
  animateScroll();
};

//t = current time
//b = start value
//c = change in value
//d = duration
Math.easeInOutQuad = function(t, b, c, d) {
  t /= d / 2;
  if (t < 1) return (c / 2) * t * t + b;
  t--;
  return (-c / 2) * (t * (t - 2) - 1) + b;
};

const navigateToSection = (section) => {
  const isSafari =
    navigator.vendor &&
    navigator.vendor.indexOf("Apple") > -1 &&
    navigator.userAgent &&
    navigator.userAgent.indexOf("CriOS") == -1 &&
    navigator.userAgent.indexOf("FxiOS") == -1;

  console.log({ navigator });

  const elementToScroll = document.documentElement;
  console.log({ elementToScroll, isSafari });

  if (section !== "section-home") {
    scrollTo(
      elementToScroll,
      document.getElementById(section).offsetTop - 20,
      800
    );
  } else {
    scrollTo(elementToScroll, document.body.offsetTop, 800);
  }
};

const onWhatsClick = () => {
  window.open(
    "https://wa.me/5511999198944?text=Ol%C3%A1%20estive%20em%20seu%20site%2C%20e%20gostaria%20de%20um%20or%C3%A7amento%2Finforma%C3%A7%C3%B5es%20sobre%20os%20varais%2C%20poderia%20entrar%20em%20contato%20por%20favor%3F!%20No%20aguardo.",
    "_blank"
  );
};

const onFacebookClick = () => {
  window.open("https://www.facebook.com/varaisalpha", "_blank");
};

const onInstagramClick = () => {
  window.open("https://www.instagram.com/varais_alpha", "_blank");
};

module.exports = {
  navigateToSection,
  onWhatsClick,
  onFacebookClick,
  onInstagramClick,
};
